import { j as m, c as o } from "./utils-BdNIfrGQ.js";
import { n as r } from "./normalize-spacing-DY0KSpr_.js";
const c = ({ spacing: s, className: a, ...i }) => /* @__PURE__ */ m.jsx("div", { className: o(a, r(s)), ...i });
c.displayName = "Div";
export {
  c as D
};
